import { render } from "./MyWesbite.vue?vue&type=template&id=2fed5c18&scoped=true"
import script from "./MyWesbite.vue?vue&type=script&lang=js"
export * from "./MyWesbite.vue?vue&type=script&lang=js"

import "./MyWesbite.vue?vue&type=style&index=0&id=2fed5c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fed5c18"]])

export default __exports__